import { useState } from "react";

export function useModelSelect() {
  const [deviceCd, setDeviceCd] = useState<string>("");
  const [deviceSubCd, setDeviceSubCd] = useState<string>("");

  const onChangeDeviceParams = (option: { value: string; label: string }) => {
    const { model, subType } = JSON.parse(option.value);
    if (!model && !subType) {
      setDeviceCd("");
      setDeviceSubCd("");
      return;
    }
    setDeviceCd(model);
    setDeviceSubCd(subType);
  };

  return { deviceCd, deviceSubCd, onChangeDeviceParams };
}
